export default {
  formId: "User",
  formField: {
    firstName: {
      name: "firstName",
      label: "First Name",
      type: "text",
      errorMsg: "First Name is required.",
      invalidMsg: "First Name is invalid",
    },
    lastName: {
      name: "lastName",
      label: "Last Name",
      type: "text",
      errorMsg: "Last Name is required.",
      invalidMsg: "Last Name is invalid",
    },
    username: {
      name: "username",
      label: "Username",
      type: "text",
      errorMsg: "Username is required.",
      invalidMsg: "Username is not valid",
    },
    email: {
      name: "email",
      label: "Email",
      type: "email",
      errorMsg: "Email is required.",
      invalidMsg: "Email is not valid",
    },
    plainPassword: {
      name: "plainPassword",
      label: "Password",
      type: "password",
      errorMsg: "Password is required.",
      invalidMsg: "Password is not valid",
    },
    payGroups: {
      name: "payGroups",
      label: "Pay Group",
      type: "multiselect",
      errorMsg: "Pay group is required.",
      invalidMsg: "Pay group is invalid",
    },
    role: {
      name: "role",
      label: "Role",
      type: "select",
      errorMsg: "Role is required.",
      invalidMsg: "Role is invalid",
    },
    status: {
      name: "status",
      label: "Status",
      type: "switch",
      errorMsg: "Status is required.",
      invalidMsg: "Status is invalid",
    },
  },
};
